module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "affiliate-program"
    }
  }, [_c('banner', [_c('router-link', {
    staticClass: "pure-color-btn",
    attrs: {
      "to": _vm.redirectUrl
    }
  }, [_vm._v(_vm._s(_vm.$t('becomeMember')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "advantage-component max-text-width"
  }, [_c('advantage')], 1), _vm._v(" "), _c('join-step', {
    staticClass: "max-text-width"
  }), _vm._v(" "), _c('div', {
    staticClass: "max-text-width",
    attrs: {
      "id": "become-affiliate"
    }
  }, [_c('commission-amount', [_c('div', {
    staticClass: "gradient-border-btn"
  }, [_c('router-link', {
    attrs: {
      "tag": "button",
      "to": _vm.redirectUrl
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('becomeMember')) + "\n        ")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71d9c190!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/affiliateProgram/Index.vue
// module id = 1353
// module chunks = 1